module.exports = __webpack_public_path__ + "img/tipper.7a467a3.svg";